import React, { useState, useEffect, useContext } from "react";
import "./Cctvinnerpage.css";
import "swiper/swiper-bundle.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useNavigate, useParams } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../utils/context";
import parse from "html-react-parser";
library.add(fas);

const CctvInnerpage = () => {
  const { id } = useParams();
  const { getData, IMG_URL } = useContext(Context);
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [mainImageSrc, setMainImageSrc] = useState("");
  const [swiperInstance, setSwiperInstance] = useState(null);

  const getDataAll = async () => {
    const response = await getData(
      `/without-login/category/all-subcategorys/${id}`,
    );

    const result = response?.data || [];
    setData(result);

    if (result.length > 0) {
      const firstImage = result[0]?.subcategory_images?.[0]?.imagePath;
      if (firstImage) {
        setMainImageSrc(IMG_URL + firstImage);
      }
    }
  };

  useEffect(() => {
    getDataAll();
  }, [id]);

  const handleMainSliderClick = (direction) => {
    if (!swiperInstance) return;

    if (direction === "prev") {
      swiperInstance.slidePrev();
    } else {
      swiperInstance.slideNext();
    }

     if (direction === "next") {
      swiperInstance.slideNext();
    } else {
      swiperInstance.slidePrev();
    }
  };

  return (
    <section className="cctv-innerpage">
      {data?.map((item, index) => (
        <div className="container" key={item.id || index}>
          <div className="row camera-sec">
            {/* LEFT SIDE IMAGE */}
            <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-12 col-12 pe-0">
              <div className="d-flex">
                <div className="leftarrowIcon">
                  <FontAwesomeIcon
                    icon="fa-solid fa-chevron-left"
                    className="leftchevronIcon"
                    onClick={() => navigate(-1)}
                  />
                </div>

                <div className="card-sec">
                  {item?.subcategory_images?.length > 0 && (
                    <div className="product-detail text-center">
                      {mainImageSrc ? (
                        <img
                          src={mainImageSrc}
                          alt={item.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            aspectRatio: "1/1",
                          }}
                        />
                      ) : (
                        <p>Image not found</p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* RIGHT SIDE CONTENT */}
            <div className="col-xxl-8 col-xl-8 col-lg-7 col-md-12 ps-0">
              <div className="IR-hover-sec">
                <div className="IR-heading">
                  <p className="text-start">{item.name}</p>
                </div>

                <div className="description">
                  <p className="text-start">{parse(item?.description || "")}</p>
                </div>
              </div>

              {/* IMAGE SLIDER */}
              <div className="camera-slider p-3">
                <div className="row">
                  <div className="col-2 col-md-1">
                    <div
                      className="main-slider-cctv"
                      onClick={() => handleMainSliderClick("prev")}
                    >
                      <div className="arrow-back" />
                    </div>
                  </div>

                  <div className="col-8 col-md-9">
                    <Swiper
                      slidesPerView={3}
                      spaceBetween={20}
                      slidesPerGroup={1}
                      modules={[Navigation, Autoplay]}
                      breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 20 },
                        380: { slidesPerView: 1.5, spaceBetween: 20 },
                        485: { slidesPerView: 2, spaceBetween: 20 },
                        575: { slidesPerView: 2, spaceBetween: 20 },
                        768: { slidesPerView: 3, spaceBetween: 20 },
                        992: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 2, spaceBetween: 20 },
                        1200: { slidesPerView: 3, spaceBetween: 20 },
                        1440: { slidesPerView: 3, spaceBetween: 20 },
                      }}
                      // autoplay={{
                      //   delay: 2500,
                      //   disableOnInteraction: false,
                      //   pauseOnMouseEnter: true,
                      // }}
                      loop={true}
                      className="mySwiper"
                      onSwiper={(swiper) => setSwiperInstance(swiper)}
                    >
                      {item?.subcategory_images?.map((img, i) => (
                        <SwiperSlide key={i}>
                          <div
                            className="camera-imgs"
                            onClick={() =>
                              setMainImageSrc(IMG_URL + img.imagePath)
                            }
                          >
                            <img
                              src={IMG_URL + img.imagePath}
                              alt="thumbnail"
                              // style={{ width: "100px", height: "100px" }}
                              className="inner-img"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div className="col-2 col-md-1">
                    <div
                      className="main-slider-cctv"
                      onClick={() => handleMainSliderClick("next")}
                    >
                      <div className="arrow-next" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* DESCRIPTION SECTION */}
          <div className="col-md-12">
            <div className="IR-dome-section">
              <div className="red-line"></div>

              <div className="IR-heading">
                <p>{item.name}</p>
              </div>

              <div className="description">
                <p>{parse(item?.sub_description || "")}</p>
              </div>

              <div className="red-line"></div>
            </div>
          </div>

          {/* CARDS */}
          <div className="cards-section">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-5 col-12 mx-lg-4">
                <div className="cards">
                  <div className="type-text-sec">
                    <p>Common Type</p>
                  </div>

                  <div className="row inner-card">
                    <div className="col-1"></div>

                    <div className="col-10">
                      <div className="security">
                        <p>{parse(item?.commontype || "")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-5 col-12 mx-lg-5 mt-3 mt-md-0">
                <div className="cards">
                  <div className="type-text-sec">
                    <p>Uses</p>
                  </div>

                  <div className="row inner-card">
                    <div className="col-1"></div>

                    <div className="col-10">
                      <div className="security">
                        <p>{parse(item?.uses || "")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default CctvInnerpage;
